import EditResourceContainer from "../containers/EditResourceContainer";

const EditResourcePage = () => {
  return (
    <EditResourceContainer />
  );
};

export default EditResourcePage;
